export default __webpack_public_path__ + "static/payperContest-05b47ecf731fa36897c87e9eb7a0356a.png";